import {
  Component, ElementRef,
  EventEmitter,
  Inject,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  SimpleChanges, ViewChild
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { DivisionsService } from '../../core/services/divisions.service';
import { NgModel } from '@angular/forms';
import Swal from 'sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { debounceTime } from "rxjs/operators";
import { cs2RanksToColor, cs2RanksToColorBg } from "../../../utils/cs2";
import { TranslationService } from "../../../../shared/services/translations.service"
import { LanguageChangeService } from "../../../../shared/services/language-change.service"


@Component({
  selector: 'app-flag-v2',
  templateUrl: './flag-content-v2.component.html',
  styleUrls: ['./flag-content-v2.component.scss']
})
export class FlagContentV2Component implements OnDestroy, OnInit {

  @Input() id: string;
  @Input() state?: string;
  // Stuff
  @Input() game: string;
  @Input() service: string;
  @Input() classes: string;
  @Input() discount: number;
  // Selectors
  @Input() showRankSelect: boolean;
  @Input() showDivisionSelect: boolean;
  @Input() showRankSelectExtended: boolean;
  @Input() showAmountSelect: boolean;
  @Input() amountEdit: boolean;
  @Input() showQueueSelect: boolean;
  @Input() showRegionSelect: boolean;
  @Input() showLpSelect: boolean;
  @Input() showPositionSelect: boolean;
  @Input() showChampionSelect: boolean;
  @Input() showMasterySelect: boolean;
  @Input() showMap: boolean;
  // Misc
  @Input() showRank: boolean;
  @Input() showQueue: boolean;
  @Input() showNumber: boolean;
  @Input() showLp: boolean;
  @Input() showRegion: boolean;
  @Input() showPlatform: boolean;
  @Input() showPlatformSelect: boolean;
  @Input() showTimeLeft: boolean;
  @Input() showChampion: boolean;
  @Input() showMastery: boolean;
  @Input() checkout: boolean;
  @Input() lockedBackground: boolean;
  // Values
  @Input() map: string;
  @Input() serviceName: string;
  @Input() desiredValue: number;
  @Input() minAmount: number;
  @Input() maxAmount: number;
  @Input() rankIcon: string;
  @Input() divisionName: string;
  @Input() champion: string;
  @Input() rankName: string;
  @Input() number: number;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() promos: string;

  @Input() lang: string;

  public autoFlash = false;

  @ViewChild('currentRankInput') currentRankInput: ElementRef;

  turnOffAutoFlash() {
    this.cookie.set('gg-flash' + this.id, '1', 3650, '/');
    this.autoFlash = false;
  }

  @Input('lp') set _lp(val: number) {
    this.lp = val;
    this.calculateMinMaxLp();
  }

  @Input() timeLeft: number;

  @Input('currentValue') set _currentValue(val: number) {
    this.currentValue = val;
    this.processCurrentValue();
    this.calculateMinMaxLp();
  }

  @Input() queue: string;
  @Input() platform: string;
  @Input() position: string;
  @Input() error: string;

  @Input('server') set _server(val: string) {
    this.server = val;
    this.calculateMinMaxLp();
  }

  @Input() price: number;
  @Input() currency: string;
  @Input() min: number;
  @Input() max: number;
  @Input() positionRequired: boolean;
  @Input() showBoosterAvailability: boolean;
  @Input() badge: number;
  @Input() completionTime: string;

  @Input('mToGmLps') set _mToGmLps(lps: any[]) {
    this.mToGmLps = lps;
    this.calculateMinMaxLp();
  }

  @Input('tftMToGmLps') set _tftMToGmLps(lps: any[]) {
    this.tftMToGmLps = lps;
    this.calculateMinMaxLp();
  }

  @Input('valorantMToGmLps') set _valorantMToGmLps(lps: any[]) {
    this.valorantMToGmLps = lps;
    this.calculateMinMaxLp();
  }

  @Output() openRankSelector = new EventEmitter<any>();
  @Output() openQueueSelector = new EventEmitter<any>();
  @Output() openPlatformSelector = new EventEmitter<any>();
  @Output() openRegionSelector = new EventEmitter<any>();
  @Output() openLpSelector = new EventEmitter<any>();
  @Output() openMapSelector = new EventEmitter<any>();
  @Output() openCheckout = new EventEmitter<any>();
  @Output() openDivisionSelector = new EventEmitter<any>();
  @Output() amountChange = new EventEmitter<number>();
  @Output() openPositionSelector = new EventEmitter<number>();
  @Output() openCharacterSelect = new EventEmitter<number>();
  @Output() openMasterySelect = new EventEmitter<number>();
  @Output() openBadgeSelect = new EventEmitter<number>();

  public isBrowser = false;
  public mToGmLps = null;
  public tftMToGmLps = null;
  public valorantMToGmLps = null;
  public divisionService = DivisionsService;
  public lp: number;
  public minLp: number;
  public maxLp: number;
  public server: string;
  public currentValue: number;
  public rankUrlPrefix = null;

  public lpLabel;

  private readonly sliderSub: Subscription;

  private amountChangeSubject: Subject<number> = new Subject();

  constructor(@Inject(PLATFORM_ID) platformId, private cookie: CookieService, private translationService: TranslationService, private languageChangeService: LanguageChangeService,) {
    this.amountChangeSubject.pipe(
      debounceTime(500)  // 500 ms debounce time
    ).subscribe(value => this.processAmountChange(value));
    if (isPlatformBrowser(platformId)) {
      this.isBrowser = true;
    }
  }

  ngOnInit() {
    this.processCurrentValue();

    if (!this.cookie.check('gg-flash' + this.id)) {
      this.autoFlash = true;
    }

    this.setLpLabel(this.state);

    if (this.game !== 'lol' && this.game !== 'wild-rift' && this.game !== 'tft') {
      this.rankUrlPrefix = this.game + '-';
    }

    if (this.game === 'lol' && this.service === 'masteries') {
      this.currentValue = parseFloat(this.cookie.get('gg-' + this.game + '-' + this.service + '-' + this.id));
    }

    this.languageChangeService.languageChanged.subscribe((newLang: string) => {
      this.lang = newLang;
      this.setLpLabel(this.state);
    });
  }

  processCurrentValue() {
    if (this.game === 'cs2' && this.id === 'current' && !this.isInputFocus) {
      this.formattedValue = this.getCs2CurrentRating(this.currentValue, this.lp);
      this.lastProcessedValue = parseInt(this.formattedValue.replace(/[^0-9]/g, ''));
    }
  }

  isInputFocus = false;
  formattedValue: string = '';
  lastProcessedValue = 0;

  // When the user moves focus out of the input, format with commas
  onInputBlur(event: any): void {
    this.isInputFocus = false;
    const value = event.target.value.replace(/,/g, ''); // remove any existing commas
    this.formattedValue = this.formatNumberWithCommas(value);
  }

  // When the user focuses on the input, remove the commas
  onInputFocus(event: any): void {
    this.formattedValue = event.target.value.replace(/,/g, '');
    this.isInputFocus = true;
  }

  formatNumberWithCommas(x: string): string {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  onAmountManualChange(event) {
    const value = parseInt(event.target.value.replace(/,/g, ''));
    this.amountChangeSubject.next(value);
  }

  private processAmountChange(value: number) {

    // If the value hasn't changed, return
    if (this.lastProcessedValue === value) {
      return;
    }

    if (this.game !== 'cs2') {
      if (value < this.min) {
        this.currentValue = this.min;
      } else if (value > this.max) {
        this.currentValue = this.max;
      } else {
        this.currentValue = value;
      }

      this.amountChange.emit(this.currentValue);
    } else {
      this.currentValue = Math.floor(value / 1000);
      this.lp = value % 1000;
      this.amountChange.emit(value);
    }

    // Update the last processed value
    this.lastProcessedValue = value;
  }

  onInputChange(event: any): void {
    const inputElem = event.target;
    const originalValue = inputElem.value;
    let cursorPosition = inputElem.selectionStart; // Get the current cursor position

    let value = originalValue.replace(/[^0-9]/g, '');  // remove all non-numeric characters

    if (value.length > 1 && value.startsWith('0')) {
      value = value.replace(/^0+/, '');  // remove leading zeros
    }

    if (value === '' || value === null || value === undefined) {
      value = '0';
    }

    // Ensure the input is numeric and within the desired range
    if (isNaN(value) || +value < 0 || +value > 34999) {
      value = this.formattedValue;  // reset to previous value if not within range
    }

    this.formattedValue = value;
    inputElem.value = this.formattedValue;  // reassign the value to the input

    const lengthDifference = this.formattedValue.length - originalValue.length;

    // Adjust the cursor position
    cursorPosition = cursorPosition + lengthDifference;
    inputElem.setSelectionRange(cursorPosition, cursorPosition);  // Restore the cursor position
  }

  getCs2CurrentRating(currentRank, lps) {
    let ratingBase = parseInt(DivisionsService.getDivisionNameByValue(currentRank, 'cs2'));
    return this.formatNumberWithCommas(ratingBase + lps);
  }

  handleClick() {
    if (this.service === 'divisions') {
      if (this.id === 'desired') {
        this.onOpenRankSelector();
      } else {
        this.currentRankInput.nativeElement.focus();
      }
    }
  }

  onOpenRankSelector() {
    this.openRankSelector.emit();
  }

  onOpenDivisionSelector() {
    this.openDivisionSelector.emit();
  }

  onOpenQueueSelector() {
    this.openQueueSelector.emit();
  }

  onOpenPlatformSelector() {
    this.openPlatformSelector.emit();
  }

  onOpenMapSelector() {
    this.openMapSelector.emit();
  }

  onOpenRegionSelector() {
    this.openRegionSelector.emit();
  }

  onOpenLpSelector() {
    this.openLpSelector.emit();
  }

  calculateMinMaxLp() {
    if (this.game === 'cs2') {
      return;
    }

    this.setLpLabel(this.state);

    if (this.game === 'wild-rift') {
      if (this.currentValue < DivisionsService.getValueByRank('Master', 'wild-rift')) {
        this.minLp = this.lp;
        this.maxLp = this.lp;
      } else {
        const sum = this.lp + 4;
        let lpString = this.lp + '-' + sum;
        this.minLp = lpString as any;
        this.maxLp = lpString as any;
      }

      return;
    }

    if (this.game === 'valorant') {
      if ((this.currentValue === DivisionsService.getValueByRank('Immortal I', 'valorant') ||
        this.currentValue === DivisionsService.getValueByRank('Immortal II', 'valorant') ||
        this.currentValue === DivisionsService.getValueByRank('Immortal III', 'valorant')) &&
        this.valorantMToGmLps && this.server) {
        const progress = this.valorantMToGmLps[this.server]
          .find(prog => prog.rank === this.currentValue && prog.minLp >= this.lp && prog.maxLp >= this.lp);
        if (!progress) {
          this.setDefaultLp();
        } else {
          this.minLp = progress.minLp;
          this.maxLp = progress.maxLp;
        }
      } else {
        this.setDefaultLp();
      }
    } else if (this.game === 'lol') {
      if (this.lp !== undefined && this.currentValue === DivisionsService.getValueByRank('Master', 'lol')
        && this.mToGmLps && this.server && this.mToGmLps[this.server]) {
        const progress = this.mToGmLps[this.server].find(prog => prog.minLp <= this.lp && prog.maxLp >= this.lp);

        if (progress) {
          this.minLp = progress.minLp;
          this.maxLp = progress.maxLp;
        } else {
          this.setDefaultLp();
        }
      } else if (this.lp !== undefined) {
        this.setDefaultLp();
      }
    } else if (this.game === 'tft') {
      if (this.lp !== undefined && this.currentValue === DivisionsService.getValueByRank('Master', 'tft')
        && this.tftMToGmLps && this.server && this.tftMToGmLps[this.server]) {
        const progress = this.tftMToGmLps[this.server].find(prog => prog.minLp <= this.lp && prog.maxLp >= this.lp);

        if (progress) {
          this.minLp = progress.minLp;
          this.maxLp = progress.maxLp;
        } else {
          this.setDefaultLp();
        }
      } else if (this.lp !== undefined) {
        this.setDefaultLp();
      }
    } else if (this.game === 'apex' || this.game === 'marvel') {
      if (this.lp !== undefined && this.currentValue !== -1) {
        this.setDefaultLp();
      }
    }
  }

  private setDefaultLp() {

    if (this.game === 'apex' && this.service !== 'badges') {
      this.minLp = this.lp;
      this.maxLp = this.minLp + 100;

      let currentDivision = DivisionsService.getDivisionNameByValue(this.currentValue, 'apex').toLowerCase();

      if (currentDivision === 'rookie') {
        this.maxLp = this.minLp + 49;
      } else if (currentDivision === 'bronze') {
        this.maxLp = this.minLp + 99;
      } else if (currentDivision === 'silver') {
        this.maxLp = this.minLp + 119;
      } else if (currentDivision === 'gold') {
        this.maxLp = this.minLp + 139;
      } else if (currentDivision === 'platinum') {
        this.maxLp = this.minLp + 159;
      } else if (currentDivision === 'diamond') {
        this.maxLp = this.minLp + 179;
      }
    }
    else {
      this.minLp = this.lp;
      this.maxLp = this.lp === 0 ? 20 : (this.lp === 81 ? 99 : (this.lp + 19));
    }
  }

  private setLpLabel(state?: string) {
    let prefix: string = 'current';
    if (state === 'initial') {
      prefix = 'starting';
    }

    if (this.game === 'wild-rift') {
      this.lpLabel = this.translationService.getTranslation(this.lang, 'marks');
    } else if (this.game === 'valorant') {
      this.lpLabel = this.translationService.getTranslation(this.lang, prefix + '_rr');
    } else if (this.game === 'apex') {
      this.lpLabel = this.translationService.getTranslation(this.lang, prefix + '_rp');
    } else if (this.game === 'marvel') {
      this.lpLabel = this.translationService.getTranslation(this.lang, prefix + '_points');
    } else {
      this.lpLabel = this.translationService.getTranslation(this.lang, prefix + '_lp');
    }

  }

  ngOnDestroy() {
    if (this.sliderSub) {
      this.sliderSub.unsubscribe();
    }
  }

  protected readonly DivisionsService = DivisionsService;
  protected readonly cs2RanksToColorBg = cs2RanksToColorBg;
  protected readonly cs2RanksToColor = cs2RanksToColor;
}
